import { IAuth, IRemoteData } from "../../../interface/IShareInfo";
import {
  getPersistData,
  setPersistData,
  removePersistData
} from "../../../commons/utils/storePersist";
import { AuthActions, AuthActionTypes } from "./actions";

export interface IRemoteAuthData extends IRemoteData<IAuth> {
  isAuthenticated?: () => boolean;
}

export const initAuthState: IRemoteAuthData = {
  loading: false,
  data: getPersistData() || {
    uid: undefined,
    role: undefined,
    token: undefined
  },
  isAuthenticated() {
    const userData = getPersistData();
    return !!(userData && userData.token);
  },
  error: undefined
};

export const authReducer = (
  state: IRemoteData<IAuth> = initAuthState,
  action: AuthActions
) => {
  switch (action.type) {
    case AuthActionTypes.SIGN_OUT_SUCCESS: {
      removePersistData();
      return {
        ...state,
        loading: false,
        error: undefined,
        data: {
          uid: undefined,
          role: undefined,
          token: undefined
        }
      };
    }

    case AuthActionTypes.AUTHENTICATE__PENDING: {
      return {
        ...state,
        data: {
          uid: undefined,
          role: undefined,
          token: undefined
        },
        error: undefined,
        loading: true
      };
    }

    case AuthActionTypes.AUTHENTICATE__SUCCESS: {
      setPersistData(action.payload);
      return {
        ...state,
        loading: false,
        error: undefined,
        data: action.payload
      };
    }

    case AuthActionTypes.AUTHENTICATE__FAILED: {
      removePersistData();
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    default: {
      return state;
    }
  }
};
